
import data from '../assets/data/support.json'
export const state = () => ({ data })
